import { React, useState, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightClassColors, getColor } from '../../Styles/theme';

import { ReactComponent as CheckIcon } from '../../image/Check.svg';

// 구버전 색상코드 → 신버전 색상코드 매핑
const legacyColorMap = {
  '#DC3E4D': '#CB4B51',
  '#F99F9F': '#ECA3A1',
  '#F17DB4': '#E283B2',
  '#9A9CE9': '#9A9CE3',
  '#80C0FB': '#8EBEF6',
  '#33C8FF': '#65C5FA',
  '#5BD98A': '#7ED691',
  '#0BB68C': '#53B38F',
};

export default function NewColorChoice(props) {
  const { selectedColor, setSelectedColor } = props;
  const { isDark } = useTheme();

  const normalizedColor = legacyColorMap[selectedColor] ?? selectedColor;

  return (
    <TopLevelWrapper>
      <ColorWrapper>
        {
          lightClassColors.map((lightColor, index) => {
            const displayColor = getColor(lightColor, isDark);
            return (
              <Color
                key={index}
                color={displayColor}
                onClick={() => setSelectedColor(lightColor)}>
                {lightColor === normalizedColor && <StyledCheckIcon />}
              </Color>
            );
          })
        }
      </ColorWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const ColorWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  background-color: ${props => props.theme.subBackground};
`;

const Color = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 46px;

  border-radius: 6px;
  background-color: ${props => props.color};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const StyledCheckIcon = styled(CheckIcon)`
  color: ${props => props.theme.white};

  width: 17px;
  height: 13px;
`;